import * as AceEditor from 'brace'

const AceRange = AceEditor.acequire('ace/range').Range
export default class IndentProcess {
  constructor(aceEditor: AceEditor.Editor) {
    aceEditor.commands.addCommand({
      name: 'Change skill outdent',
      exec: this.outdent,
      bindKey: 'Shift-Tab'
    })

    aceEditor.commands.addCommand({
      name: 'Change skill indent',
      exec: this.indent,
      bindKey: 'Tab'
    })
  }

  public outdent(editor: AceEditor.Editor) {
    const currentRow = editor.selection.getCursor().row
    const match = editor.session.getLine(currentRow).match(/^\s*-((.|\n)*)$/)
    if (!match) return false
    editor.session.replace(new AceRange(currentRow, 0, currentRow, Number.MAX_VALUE), `+${match[1]}`)
  }

  public indent(editor: AceEditor.Editor) {
    const currentRow = editor.selection.getCursor().row
    const match = editor.session.getLine(currentRow).match(/^\s*\+(.*)$/)
    if (!match) return false
    editor.session.replace(new AceRange(currentRow, 0, currentRow, Number.MAX_VALUE), `  -${match[1]}`)
  }
}
